import { Product } from "./product";

export const enum DiscountType {
  PERCENTAGE = "PERCENTAGE",
  AMOUNT = "AMOUNT",
}

export interface Discount  {
  id?: string;
  product_id?: string;
  product?: Product;
  type: DiscountType;
  value: number;
  start_date: Date;
  end_date?: Date | null;
  is_active: boolean;
  notes?: string;

}
